/* eslint-disable import/no-extraneous-dependencies */
import Typography from 'typography';
/* eslint-enable import/no-extraneous-dependencies */

const typography = new Typography({
  blockMarginBottom: '0',
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js